import React, { createContext, useReducer, useEffect, useContext, useState } from "react";
import { Tabs, Row, Col, Button, Input, Select, Switch, Form, message } from 'antd';
import { UserOutlined, LaptopOutlined, NotificationOutlined, DeleteFilled, ZoomInOutlined, PlusOutlined } from '@ant-design/icons';
import MainLayout from '../../common/layout';
import Advice from './advice';
import Instructions from './instructions';
import Medications from './medications';
import Investigation from './investigation';
import Procedure from './procedure';
import { layout } from '../../commonImports/import1';
import slugify from 'slugify';
import { createOrderSet, updateOrderSet } from '../../../graphql/mutations';
import Diagnosis from './diagnosis';
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import { ageGroup, genderValues } from '../../commonImports/data';

const { TabPane } = Tabs;


const updateOrderSetMut=async(props,variables)=>{
  return await new Promise((res,rej)=>{
     props.client.mutate({
       mutation: updateOrderSet,
       variables:variables,
     }).then(({data})=>{
       res(data)
     }).catch((err)=>{
       rej(err)
     })
   })
 };

 const createOrderSetMut=async(props,variables)=>{
  return await new Promise((res,rej)=>{
     props.client.mutate({
       mutation: createOrderSet,
       variables:variables,
     }).then(({data})=>{
       res(data)
     }).catch((err)=>{
       rej(err)
     })
   })
 };


const CreateOrdersets = (props) => {
    let record = null;
    let flow = 'CREATE';

    if(props.location.state && props.location.state.record){
      record = props.location.state.record;
      flow = 'UPDATE'
      if(record.action =='clone'){
        flow = 'CREATE'
      }
    }

    const [form] = Form.useForm();
    const [loading,setloading] = useState(false);
    const [module,setmodule] = useState(flow);


    let initialValues={};
    if(record != null){
      initialValues = {...record}
      initialValues.diagnosis = [{ key : record.diagnosis, value : record.diagnosis, label: record.diagnosis}]
      if(record.action == 'clone'){
        delete initialValues.diagnosis
      }
      if(record.ageGroup){
        initialValues.ageGroup = record.ageGroup.map((a)=>a.type)
      }else{
        initialValues.ageGroup = undefined
      }
    }


    useEffect(() => {
      setmodule(flow)
    }, [flow])


    const runMutation=(arr)=>{
      setloading(true)
      Promise.allSettled(arr)
      .then((res)=>{
        setTimeout(() => {
          message.success('Successfully done')
          props.history.push('/manageOrdersets')
          setloading(false)
        }, 400);
     
      })
      .catch((err)=>{
        console.log(err)
        if (err.graphQLErrors)
        err.graphQLErrors.map((res) =>{
          if(res.errorType == 'DynamoDB:ConditionalCheckFailedException'){
            message.error('This orderset is already created.')
          }else{
            message.error('There is some error in saving form')
          }
        });    
        if (err.networkError) console.log(`[Network error]: ${err.networkError}`);
          setloading(false)
      })
    }

    
    const createOrsersetMutationFunc=(obj)=>{
      return new Promise(async(resolve, reject)=>{
        let objCopy = {...obj}
        try{
          let res = await updateOrderSetMut(props, obj);
          if(res.updateOrderSet != null){
            resolve(res)
          }else{
            reject('Error')
          }
        }catch(err){
          if (err.graphQLErrors)
            err.graphQLErrors.map(async(res) =>{
              if(res.errorType == 'DynamoDB:ConditionalCheckFailedException'){   
                // reject(objCopy)
                // console.log('abc')
              try{
                  let res2 = await createOrderSetMut(props,objCopy)
                  if(res2.createOrderSet != null){
                    resolve(res2)
                  }else{
                    reject('Error')
                  }

                }catch(e){
                  reject(e)
                }
              
              }else{
                reject(err)
              }
            });    
            if (err.networkError) console.log(`[Network error]: ${err.networkError}`);
            reject(err)
        }
      })
    }

    return (
        <MainLayout>
            <Form
                initialValues={initialValues}
                form={form}
                {...layout}
                onFinish={(values) => {
                
                  let ageGroupItem = [];
                  if(values.ageGroup){
                    ageGroupItem = ageGroup.filter((a)=>values.ageGroup.includes(a.type))
                  }
         
                  if(Array.isArray(values.diagnosis)){
                    let obj = {}
                    let typeValue = 'global';
                 
                    let advice = values.advice && values.advice.length > 0 ? values.advice.map((a)=>{
                      if(typeof a == 'string'){
                        return a
                      }else{
                        return a.slugValue
                      }
                    }) : [];

                    let procedure = values.procedure && values.procedure.length > 0 ? values.procedure.map((a)=>{
                      if(typeof a == 'string'){
                        return a
                      }else{
                        return a.id
                      }
                    }) : [];

                    let medication = values.medication && values.medication.length > 0 ? values.medication.map((a)=>{
                      delete a['__typename']
                      return a
                  }) : [];

                    let investigation = values.investigation && values.investigation.length > 0 ? values.investigation.map((a)=>{
                   
                      if(typeof a == 'string'){
                        return a
                      }else{
                        return a.id
                      }
                    }) : [];


                      obj = { 
                        typeValue : typeValue, 
                        // slugValue: slugValue, 
                        orderSetName: values.orderSetName,
                        // diagnosis : values.diagnosis,
                        searchField: values.orderSetName.trim().toLowerCase(),
                        advice : advice.length > 0 ? advice : flow == 'CREATE' ? undefined : null, 
                        procedure : procedure && procedure.length > 0 ? procedure : flow == 'CREATE' ? undefined :  null, 
                        medication : medication && medication.length > 0 ? medication : flow == 'CREATE' ? undefined : null, 
                        note : values.note,
                        investigation : investigation && investigation.length > 0 ? investigation : flow == 'CREATE' ? undefined : null,
                        active: values.active != undefined || values.active != null ? values.active : true,
                        ageGroup: ageGroupItem.length > 0 ? ageGroupItem : flow == 'CREATE' ? undefined :  null,
                        appliedFor: values.appliedFor
              
                    }
    
                    let arr = []
                    values.diagnosis.forEach((v)=>{
                      obj.diagnosis = v.value;
                      let slugValue = `${slugify(values['orderSetName'].trim(),{
                        lower:true
                      })}::${v.value}`;
                      obj.slugValue = slugValue;
                   
                        arr.push(
                          createOrsersetMutationFunc(obj)
                        )
                    })
                
                    runMutation(arr)
                  }
                }}

                onFinishFailed={(err) => {
                 message.error('Please check all fields')
                }}
            >
                <Row gutter={24}>
                    <Col span={6}>
                        <Form.Item
                            label="Order set name"
                            name="orderSetName"
                            rules={[{ required: true, message: 'Please enter Order set name' }]}
                        >
                            <Input placeholder="Order set name"/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="Diagnosis"
                            name="diagnosis"
                            rules={[{ required: true, message: 'Please select Diagnosis' }]}
                        >
                            <Diagnosis form={form} />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        name="ageGroup"
                        label="Age Group"
                        >
                      <Select mode="multiple"  placeholder="Age Group" allowClear style={{width:'100%'}}>
                       {ageGroup.map((a)=>{
                          return(
                            <Select.Option key={a.type} value={a.type}>
                              {a.type +' '+ a.ageFrom+' - '+a.ageTo + ' ' +'Yr'} 
                            </Select.Option>
                          )
                        })} 
                      </Select>
                      </Form.Item>
                      </Col>
                      <Col span={6}>
                      <Form.Item
                        name="appliedFor"
                        label="Gender"
                        >
                      <Select  placeholder="Gender" allowClear style={{width:'100%'}}>
                        {genderValues.map((a)=>{
                          return(
                            <Select.Option key={a} value={a}>
                              {a}
                            </Select.Option>
                          )
                        })}
                      </Select>
                      </Form.Item>
                      </Col>
                      <Col>
                      <Form.Item
                        name="active"
                        // label="Status"
                        >
                      {/* <Switch size="small" 
                      checked={record ? record.active : true} 
                      onChange={(checked) => {
                            form.setFieldsValue({
                              active: checked
                            })
                    }} /> */}
                    <p></p>
                    </Form.Item>
                    </Col>
                    <Col style={{display:'flex', alignItems:'flex-end'}}>
                        <Button id="createdOrderSetBtn" type="primary" htmlType="submit" loading={loading} 
                        style={{marginBottom:'20px'}}>
                          { module == 'UPDATE' ? 'Update' : 'Create'}</Button>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="5" >
                <TabPane forceRender={true} tab="Investigations" key="5">
                        <Investigation form={form}/>
                    </TabPane>
                    <TabPane forceRender={true} tab="Procedures" key="4">
                        <Procedure form={form}/>
                    </TabPane>
                    <TabPane forceRender={true} tab="Medication" key="3">
                        <Medications form={form}/>
                    </TabPane>
               
                    <TabPane forceRender={true} tab="Advice" key="2">
                        <Advice form={form}/>
                    </TabPane>
                    <TabPane forceRender={true} tab="Instructions" key="1">
                        <Instructions form={form}/>
                    </TabPane>
                </Tabs>
            </Form>
        </MainLayout>
    )
}

export default withApollo(withRouter(CreateOrdersets));